export default "__VITE_ASSET__CrUo_Evt__"